import apiClient from "../../api/client";

// =============================================
// HELPER FUNCTIONS
// =============================================

const extractData = (response) => {
  if (response?.data?.data?.data && Array.isArray(response.data.data.data)) {
    return response.data.data.data;
  }
  if (response?.data?.data && Array.isArray(response.data.data)) {
    return response.data.data;
  }
  if (response?.data && Array.isArray(response.data)) {
    return response.data;
  }
  if (Array.isArray(response)) {
    return response;
  }
  return [];
};

const extractSingle = (response) => {
  if (response?.data?.data) {
    return response.data.data;
  }
  if (response?.data) {
    return response.data;
  }
  return response;
};

// =============================================
// BOOKING CRUD OPERATIONS
// =============================================

export const getBookings = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });

    const response = await apiClient.get(`/bookings${params.toString() ? `?${params.toString()}` : ''}`);
    console.log("Get bookings response:", response);

    return extractData(response);
  } catch (error) {
    console.error("Error fetching bookings:", error);
    return [];
  }
};

export const getBookingById = async (id) => {
  try {
    const response = await apiClient.get(`/bookings/${id}`);
    return extractSingle(response);
  } catch (error) {
    console.error("Error fetching booking by ID:", error);
    throw error;
  }
};

// export const createBooking = async (bookingData) => {
//   try {
//     console.log("📦 Creating booking with data:", bookingData);

//     const payload = {
//       customer_id: bookingData.customerId,
//       connection_id: bookingData.connectionId || null,
//       cylinder_type_id: bookingData.cylinderTypeId,
//       brand_id: bookingData.brandId || null,
//       booking_source: bookingData.bookingSource || "walk-in",
//       booking_date: bookingData.bookingDate || new Date().toISOString(),
//       preferred_delivery_date: bookingData.preferredDeliveryDate,
//       delivery_slot: bookingData.deliverySlot || "anytime",
//       delivery_instructions: bookingData.deliveryInstructions || null,
//       quantity: Number(bookingData.quantity) || 1,
//       unit_price: Number(bookingData.unitPrice) || 0,
//       total_amount: Number(bookingData.totalAmount) || 0,
//       advance_paid: Number(bookingData.advancePaid) || 0,
//       booking_status: bookingData.bookingStatus || "booked",
//       notes: bookingData.notes || null,
//       created_by: bookingData.createdBy || null,
//     };

//     console.log("📤 Sending booking payload:", JSON.stringify(payload, null, 2));
//     const response = await apiClient.post("/bookings", payload);
//     console.log("✅ Create booking response:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("❌ Error creating booking:", error);
//     throw error;
//   }
// };

// export const updateBooking = async (id, bookingData) => {
//   try {
//     console.log(`📦 Updating booking ${id}:`, bookingData);
//     const response = await apiClient.put(`/bookings/${id}`, bookingData);
//     return response.data;
//   } catch (error) {
//     console.error("Error updating booking:", error);
//     throw error;
//   }
// };

// src/components/services/bookingService.js

export const createBooking = async (bookingData) => {
  try {
    console.log("📦 Creating booking with data:", bookingData);

    // ✅ Support both camelCase and snake_case
    const customerId = bookingData.customer_id || bookingData.customerId;
    const connectionId = bookingData.connection_id || bookingData.connectionId;
    const cylinderTypeId = bookingData.cylinder_type_id || bookingData.cylinderTypeId;
    const brandId = bookingData.brand_id || bookingData.brandId;
    const bookingSource = bookingData.booking_source || bookingData.bookingSource || "walk-in";
    const bookingDate = bookingData.booking_date || bookingData.bookingDate || new Date().toISOString();
    const preferredDeliveryDate = bookingData.preferred_delivery_date || bookingData.preferredDeliveryDate;
    const deliverySlot = bookingData.delivery_slot || bookingData.deliverySlot || "anytime";
    const deliveryInstructions = bookingData.delivery_instructions || bookingData.deliveryInstructions || null;
    const quantity = bookingData.quantity || 1;
    const unitPrice = bookingData.unit_price || bookingData.unitPrice || 0;
    const totalAmount = bookingData.total_amount || bookingData.totalAmount || 0;
    const advancePaid = bookingData.advance_paid || bookingData.advancePaid || 0;
    const bookingStatus = bookingData.booking_status || bookingData.bookingStatus || "booked";
    const notes = bookingData.notes || null;
    const createdBy = bookingData.created_by || bookingData.createdBy || null;

    const payload = {
      customer_id: parseInt(customerId),
      connection_id: connectionId ? parseInt(connectionId) : null,
      cylinder_type_id: parseInt(cylinderTypeId),
      brand_id: brandId ? parseInt(brandId) : null,
      booking_source: bookingSource,
      booking_date: bookingDate,
      preferred_delivery_date: preferredDeliveryDate,
      delivery_slot: deliverySlot,
      delivery_instructions: deliveryInstructions,
      quantity: parseInt(quantity) || 1,
      unit_price: parseFloat(unitPrice) || 0,
      total_amount: parseFloat(totalAmount) || 0,
      advance_paid: parseFloat(advancePaid) || 0,
      booking_status: bookingStatus,
      notes: notes,
      created_by: createdBy,
    };

    console.log("📤 Sending booking payload:", JSON.stringify(payload, null, 2));
    const response = await apiClient.post("/bookings", payload);
    console.log("✅ Create booking response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error creating booking:", error);
    throw error;
  }
};

// Also update updateBooking function
export const updateBooking = async (id, bookingData) => {
  try {
    console.log(`📦 Updating booking ${id}:`, bookingData);

    // ✅ Support both camelCase and snake_case
    const customerId = bookingData.customer_id || bookingData.customerId;
    const connectionId = bookingData.connection_id || bookingData.connectionId;
    const cylinderTypeId = bookingData.cylinder_type_id || bookingData.cylinderTypeId;
    const brandId = bookingData.brand_id || bookingData.brandId;
    const bookingSource = bookingData.booking_source || bookingData.bookingSource;
    const bookingDate = bookingData.booking_date || bookingData.bookingDate;
    const preferredDeliveryDate = bookingData.preferred_delivery_date || bookingData.preferredDeliveryDate;
    const deliverySlot = bookingData.delivery_slot || bookingData.deliverySlot;
    const deliveryInstructions = bookingData.delivery_instructions || bookingData.deliveryInstructions;
    const quantity = bookingData.quantity;
    const unitPrice = bookingData.unit_price || bookingData.unitPrice;
    const totalAmount = bookingData.total_amount || bookingData.totalAmount;
    const advancePaid = bookingData.advance_paid || bookingData.advancePaid;
    const bookingStatus = bookingData.booking_status || bookingData.bookingStatus;
    const notes = bookingData.notes;

    const payload = {
      customer_id: customerId ? parseInt(customerId) : null,
      connection_id: connectionId ? parseInt(connectionId) : null,
      cylinder_type_id: cylinderTypeId ? parseInt(cylinderTypeId) : null,
      brand_id: brandId ? parseInt(brandId) : null,
      booking_source: bookingSource,
      booking_date: bookingDate,
      preferred_delivery_date: preferredDeliveryDate,
      delivery_slot: deliverySlot,
      delivery_instructions: deliveryInstructions || null,
      quantity: parseInt(quantity) || 1,
      unit_price: parseFloat(unitPrice) || 0,
      total_amount: parseFloat(totalAmount) || 0,
      advance_paid: parseFloat(advancePaid) || 0,
      booking_status: bookingStatus || "booked",
      notes: notes || null,
    };

    console.log("📤 Sending update payload:", JSON.stringify(payload, null, 2));
    const response = await apiClient.put(`/bookings/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating booking:", error);
    throw error;
  }
};

export const deleteBooking = async (id) => {
  try {
    const response = await apiClient.delete(`/bookings/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting booking:", error);
    throw error;
  }
};

// =============================================
// BOOKING STATUS MANAGEMENT
// =============================================

export const updateBookingStatus = async (id, statusData) => {
  try {
    console.log(`📦 Updating booking ${id} status:`, statusData);
    const response = await apiClient.patch(`/bookings/${id}/status`, statusData);
    return response.data;
  } catch (error) {
    console.error("Error updating booking status:", error);
    throw error;
  }
};

export const cancelBooking = async (id, cancelData = {}) => {
  try {
    const response = await apiClient.patch(`/bookings/${id}/cancel`, cancelData);
    return response.data;
  } catch (error) {
    console.error("Error cancelling booking:", error);
    throw error;
  }
};

export const rescheduleBooking = async (id, rescheduleData) => {
  try {
    const response = await apiClient.patch(`/bookings/${id}/reschedule`, rescheduleData);
    return response.data;
  } catch (error) {
    console.error("Error rescheduling booking:", error);
    throw error;
  }
};

// =============================================
// DELIVERY ASSIGNMENT
// =============================================

export const assignDeliveryBoy = async (id, deliveryBoyId) => {
  try {
    const response = await apiClient.patch(`/bookings/${id}/assign`, { delivery_boy_id: deliveryBoyId });
    return response.data;
  } catch (error) {
    console.error("Error assigning delivery boy:", error);
    throw error;
  }
};

export const markOutForDelivery = async (id, data = {}) => {
  try {
    const response = await apiClient.patch(`/bookings/${id}/out-for-delivery`, data);
    return response.data;
  } catch (error) {
    console.error("Error marking out for delivery:", error);
    throw error;
  }
};

export const markDelivered = async (id, data = {}) => {
  try {
    const response = await apiClient.patch(`/bookings/${id}/delivered`, data);
    return response.data;
  } catch (error) {
    console.error("Error marking delivered:", error);
    throw error;
  }
};

// =============================================
// BOOKING STATISTICS
// =============================================

export const getBookingStatistics = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key]) queryParams.append(key, params[key]);
    });
    const response = await apiClient.get(`/bookings/stats${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
    return extractSingle(response);
  } catch (error) {
    console.error("Error fetching booking statistics:", error);
    return {};
  }
};

export const getBookingByNumber = async (bookingNumber) => {
  try {
    const response = await apiClient.get(`/bookings/number/${bookingNumber}`);
    return extractSingle(response);
  } catch (error) {
    console.error("Error fetching booking by number:", error);
    throw error;
  }
};

// =============================================
// DELIVERY BOYS
// =============================================

export const getDeliveryBoys = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key]) queryParams.append(key, params[key]);
    });
    const response = await apiClient.get(`/delivery-boys${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
    return extractData(response);
  } catch (error) {
    console.error("Error fetching delivery boys:", error);
    return [];
  }
};

export const getDeliverySchedules = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key]) queryParams.append(key, params[key]);
    });
    const response = await apiClient.get(`/delivery-schedules${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
    return extractData(response);
  } catch (error) {
    console.error("Error fetching delivery schedules:", error);
    return [];
  }
};

export const createDeliverySchedule = async (scheduleData) => {
  try {
    const response = await apiClient.post("/delivery-schedules", scheduleData);
    return response.data;
  } catch (error) {
    console.error("Error creating delivery schedule:", error);
    throw error;
  }
};

// Export all
export default {
  getBookings,
  getBookingById,
  createBooking,
  updateBooking,
  deleteBooking,
  updateBookingStatus,
  cancelBooking,
  rescheduleBooking,
  assignDeliveryBoy,
  markOutForDelivery,
  markDelivered,
  getBookingStatistics,
  getBookingByNumber,
  getDeliveryBoys,
  getDeliverySchedules,
  createDeliverySchedule,
};